import { render, staticRenderFns } from "./menu-pautaTrimestral.vue?vue&type=template&id=67eb540e&"
import script from "./menu-pautaTrimestral.vue?vue&type=script&lang=js&"
export * from "./menu-pautaTrimestral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports